import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import {
  GETNotificacaoConfiguracoes,
  POSTNotificacaoConfiguracao,
  PUTNotificacaoConfiguracao,
} from 'requests/notificacao';
import {
  NotificacaoConfiguracaoRequest,
  NotificacaoConfiguracaoResponse,
  AtualizarNotificacaoConfiguracaoRequest,
} from 'common/genericTypes';

export interface NotificacaoApiState {
  getConfiguracoes(
    dispatch: Dispatch,
    participanteId: string,
    stackRequest?: boolean
  ): Promise<NotificacaoConfiguracaoResponse[]>;
  postConfiguracao(
    dispatch: Dispatch,
    participanteId: string,
    configuracao: NotificacaoConfiguracaoRequest,
    stackRequest?: boolean
  ): Promise<NotificacaoConfiguracaoResponse>;
  putConfiguracao(
    dispatch: Dispatch,
    configuracaoId: string,
    configuracao: AtualizarNotificacaoConfiguracaoRequest,
    stackRequest?: boolean
  ): Promise<NotificacaoConfiguracaoResponse>;
}

const notificacaoApiInitialState: NotificacaoApiState = {
  getConfiguracoes: GETNotificacaoConfiguracoes,
  postConfiguracao: POSTNotificacaoConfiguracao,
  putConfiguracao: PUTNotificacaoConfiguracao,
};

enum NotificacaoApiActionType {
  Update = 'notificacaoApi/UPDATE',
  Reset = 'notificacaoApi/RESET',
}

export const updateNotificacaoApi = (state: NotificacaoApiState) => {
  return typedAction(NotificacaoApiActionType.Update, state);
};

export const resetNotificacaoApi = () => {
  return typedAction(NotificacaoApiActionType.Reset);
};

type NotificacaoApiAction = ReturnType<typeof updateNotificacaoApi | typeof resetNotificacaoApi>;

export function notificacaoApiReducer(
  state: NotificacaoApiState = notificacaoApiInitialState,
  action: NotificacaoApiAction
): NotificacaoApiState {
  switch (action.type) {
    case NotificacaoApiActionType.Update:
      return { ...action.payload };
    case NotificacaoApiActionType.Reset:
      return { ...notificacaoApiInitialState };
    default:
      return state;
  }
}
